/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import clsx from 'clsx'
import {updateQuery} from '../slices/cdrFilterSlice'
import PageLink from '../../../template/helpers/pagination/PageLink'
import {useAppDispatch, useAppSelector} from '../../../hooks/redux'
import {getPaginationItems} from '../../../template/helpers/pagination/pagination'
import {shallowEqual} from 'react-redux'

interface Props {
  maxLength: number
}

const Pagination: FC<Props> = ({maxLength}) => {
  const dispatch = useAppDispatch()
  const maxLengthDefault: number = 7

  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)
  const limit = query?.limit ?? 10
  const offset = query?.offset ?? 0

  const currentPage = Math.floor(offset / limit) + 1
  const lastPage = Math.max(1, Math.ceil(maxLength / limit))
  const pageNums = getPaginationItems(currentPage, lastPage, maxLengthDefault)

  return (
    <div className='col-sm-12 col-md-10 d-flex align-items-center justify-content-center justify-content-md-end'>
      <div id='kt_table_users_paginate'>
        <ul className='pagination'>
          <li className={clsx('page-item previous', {disabled: currentPage === 1})}>
            <PageLink
              className='page-link'
              style={{cursor: 'pointer'}}
              disabled={currentPage === 1}
              onClick={() => {
                if (currentPage === 1) return
                dispatch(updateQuery({offset: query?.offset! - query?.limit!}))
              }}
            >
              <i className='previous' />
            </PageLink>
          </li>
          {pageNums.map((pageNum, idx) => (
            <li
              key={idx}
              className={clsx('page-item', {
                active: currentPage === pageNum || pageNums.length === 1,
              })}
            >
              <PageLink
                key={idx}
                className='page-link'
                active={currentPage === pageNum || pageNums.length === 1}
                disabled={isNaN(pageNum)}
                onClick={() => {
                  dispatch(updateQuery({offset: query?.limit! * (pageNum - 1)}))
                }}
              >
                {!isNaN(pageNum) ? pageNum : '...'}
              </PageLink>
            </li>
          ))}
          <li
            className={clsx('page-item next', {
              disabled: currentPage === lastPage,
            })}
          >
            <PageLink
              className='page-link'
              disabled={currentPage === lastPage}
              onClick={() => {
                if (currentPage === lastPage) return
                dispatch(updateQuery({offset: query?.offset! + query?.limit!}))
              }}
            >
              <i className='next' />
            </PageLink>
          </li>
        </ul>
      </div>
    </div>
  )
}

export {Pagination}
